import { Checkbox, Divider, message } from "antd"
import React, { useEffect, useState } from "react"
import { useNavigate, useParams  } from "react-router-dom"
import Button from "../../components/UI/Button"
import Input from "../../components/UI/Input"
import { sendSystemLog, useAuth } from "../../context/AuthProvider/useAuth"
import { getBingoConfiguration, updateBingoConfiguration } from "../../services/bingoConfiguration"
import { notificationError } from "../../services/notification"
import { onlyNumbers, onlySpaces } from "../../utils/formValidation"

function BingoConfiguration(props: {accessLevel: string}) {
  const {canEdit} = useAuth()
  const history = useNavigate()
  const [form, setForm] = useState({
    maximum_wait: "",
    minimum_wait: "",
    max_players: "",
    display_ssn: ""
  })
  const [orig, setOrig] = useState({
    maximum_wait: "",
    minimum_wait: "",
    max_players: "",
    display_ssn: ""
  })
  const log = {
    log_type: 'visited',
    log_object: 'bingo config'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, []);

  useEffect(() => {
    (async () => {
      await getConfig()
    })()
  }, [])

  const getConfig = async () => {
    const res = await getBingoConfiguration()
    if (res) {
      setForm(res)
      setOrig(res)
    }

  }
  const onSubmit = async () => {
    if(parseInt(form.maximum_wait) < 100) return notificationError("Maximum waiting time can't be lower than 100")
    if(parseInt(form.minimum_wait) < 100) return notificationError("Minimum waiting time can't be lower than 100")
    if(parseInt(form.maximum_wait) - parseInt(form.minimum_wait) < 500) return notificationError("Minimum and maximum waiting time should have a difference of 500 millis")
    if(parseInt(form.max_players) < 2) return notificationError("Max players can't be lower than 2")
    await updateBingoConfiguration(form)
    await getConfig()
  }

  const isValid = () => {
    if(!form.max_players || !form.minimum_wait || !form.maximum_wait) return false
    if((parseInt(form.maximum_wait) < 100) || (parseInt(form.minimum_wait) < 100)) return false
    if(parseInt(form.max_players) < 2) return false
    return true
  }

  const isChanged = () => {
    if(!form.max_players || !form.minimum_wait || !form.maximum_wait) return false
    if(parseInt(form.maximum_wait)!==parseInt(orig.maximum_wait)) return true
    if(parseInt(form.minimum_wait)!==parseInt(orig.minimum_wait)) return true
    if(parseInt(form.display_ssn)!==parseInt(orig.display_ssn)) return true
    return parseInt(form.max_players) !== parseInt(orig.max_players);

  }

  return (
    <div className="bingo-configuration">
      <meta name="viewport" content="width=device-width, initial-scale=.75"/>
      <div className="bingo-configuration__inputs">
        <Input
          label="Maximum waiting time (can't be lower than 100) - (milliseconds)"
          value={form.maximum_wait}
          onChange={(e: any) => setForm((prev) => ({...prev, maximum_wait: onlyNumbers(e.target.value)}))}
        />
        <Input
          label="Minimum waiting time (can't be lower than 100) - (milliseconds)"
          value={form.minimum_wait}
          onChange={(e: any) => setForm((prev) => ({...prev, minimum_wait: onlyNumbers(e.target.value)}))}
        />
        <Input
          label="Max number of players per round (can't be lower than 2)"
          value={form.max_players}
          onChange={(e: any) => setForm((prev) => ({...prev, max_players: onlyNumbers(e.target.value)}))}
        />
      </div>
      <Divider />
      <div className="bingo-configuration__inputs">
        <Input
          label="Minimum jackpot value to display SSN"
          value={form.display_ssn}
          onChange={(e: any) => setForm((prev) => ({...prev, display_ssn: onlyNumbers(e.target.value)}))}
        />
      </div>
      <Divider />
      <div className="bingo-configuration__buttons">
        <Button onClick={() => history(-1)} type='secondary'>
          <p id="cancel-button">Cancel</p>
        </Button>
        <Button onClick={() => onSubmit()} type='primary' disabled={!isValid() || !canEdit || !isChanged()}>
          <p id="save-button">Save</p>
        </Button>
      </div>
    </div>
  )
}

export default BingoConfiguration


